import React from "react";

const Info = () => {
  return (
    <div className="flex flex-col h-full text-white">
      <div className="w-7/12 text-left mx-auto text-sm leading-6">
        <h1 className="py-6 text-2xl text-gold font-semibold">Info page</h1>
        <h2 className="font-semibold text-gold">P&P Exclusive Cars</h2>
        <p>Salmgasse 5, 1030 Wien</p>
        <p className="pt-6">UID-Nummer: ATU77547415</p>
        <p>FN: 567321 x</p>
        <p>FB-Gericht: Handelsgericht Wien</p>

        <h2 className="pt-6 font-semibold text-gold">
          Kontakt: Office Punkt vor Strich
        </h2>
        <p>Tel: + 43 (0) 650 / 4150590</p>
        <p>office@punkt-vor-strich.at</p>

        <h2 className="pt-6 font-semibold text-gold">
          Bankverbindungen &amp; Überweisungen:
        </h2>
        <p>Erste Bank</p>
        <p>IBAN: AT06 2011 1844 8156 3400</p>
        <p>BIC: GIBBAATWWXXX</p>

        <h2 className="pt-10 font-semibold text-gold">Copyright</h2>
        <p>
          Für den Inhalt und für die Richtigkeit ist PvS verantwortlich. Alle
          Texte und Bilder unterliegen dem Copyright. Diese Texte und Bilder
          dürfen ohne Genehmigung von PvS weder kopiert noch auf irgend eine
          andere Weise vervielfältigt werden. Von Texten und Inhalten zu
          verlinkten Seiten distanzieren wir uns und übernehmen keine Haftung
          für deren Inhalte oder Verlinkungen!
        </p>

        <h2 className="pt-10 font-semibold text-gold">Google Analytics</h2>
        <p className="pb-10 mb-10">
          Diese Website benutzt Google Analytics, einen Webanalysedienst der
          Google Inc. („Google“). Google Analytics verwendet sog. „Cookies“,
          Textdateien, die auf Ihrem Computer gespeichert werden und die eine
          Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den
          Cookie erzeugten Informationen über Ihre Benutzung dieser Website
          werden in der Regel an einen Server von Google in den USA übertragen
          und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung
          auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb
          von Mitgliedstaaten der Europäischen Union oder in anderen
          Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum
          zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an
          einen Server von Google in den USA übertragen und dort gekürzt. Im
          Auftrag des Betreibers dieser Website wird Google diese Informationen
          benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
          Websiteaktivitäten zusammenzustellen und um weitere mit der
          Websitenutzung und der Internetnutzung verbundene Dienstleistungen
          gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von Google
          Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit
          anderen Daten von Google zusammengeführt. Sie können die Speicherung
          der Cookies durch eine entsprechende Einstellung Ihrer
          Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass
          Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
          Website vollumfänglich werden nutzen können. Sie können darüber hinaus
          die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der
          Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
          Verarbeitung dieser Daten durch Google verhindern, indem sie das unter
          dem folgenden Link (http://tools.google.com/dlpage/gaoptout?hl=de)
          verfügbare Browser-Plugin herunterladen und installieren. Nähere
          Informationen hierzu finden Sie unter
          http://tools.google.com/dlpage/gaoptout?hl=de bzw. unter
          http://www.google.com/intl/de/analytics/privacyoverview.html
          (allgemeine Informationen zu Google Analytics und Datenschutz). Wir
          weisen Sie darauf hin, dass auf dieser Webseite Google Analytics um
          den Code „gat._anonymizeIp();“ erweitert wurde, um eine anonymisierte
          Erfassung von IP-Adressen (sog. IP-Masking) zu gewährleisten.
        </p>
      </div>
    </div>
  );
};

export default Info;
